import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Home, CalendarDays, Phone, User } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface BottomTabBarProps {
  currentTab: string;
  onTabChange: (tab: string) => void;
}
export function BottomTabBar({
  currentTab,
  onTabChange
}: BottomTabBarProps) {
  const {
    isLight
  } = useTheme();
  const tabs = [{
    id: 'home',
    label: 'Home',
    icon: Home
  }, {
    id: 'calls',
    label: 'Calls',
    icon: Phone
  }, {
    id: 'calendar',
    label: 'Calendar',
    icon: CalendarDays
  }, {
    id: 'profile',
    label: 'Account',
    icon: User
  }];
  return <div className="absolute bottom-0 left-0 right-0 z-40 flex justify-center pb-5 px-4 pointer-events-none" data-tour="bottom-tabs" data-id="element-1042" data-mp="1gtiwiguf30jt">
      <motion.nav initial={{
      y: 16,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      type: 'spring',
      stiffness: 420,
      damping: 32,
      delay: 0.1
    }} className={`pointer-events-auto w-full max-w-[290px] rounded-full px-2 py-[3px] backdrop-blur-2xl border transition-colors duration-500
          ${isLight ? 'bg-white border-slate-200 shadow-[0_-2px_12px_rgba(0,0,0,0.08),0_4px_20px_rgba(0,0,0,0.06)]' : 'bg-[#111111] border-white/[0.08] shadow-[0_-2px_12px_rgba(0,0,0,0.3),0_4px_24px_rgba(0,0,0,0.4)]'}`} data-id="element-1043" data-mp="ac5k62fa8g2a">
        <div className="flex items-center justify-around" data-id="element-1044" data-mp="1847fqkdbn1hn">
          {tabs.map(tab => {
          const isActive = currentTab === tab.id;
          const Icon = tab.icon;
          const isCalls = tab.id === 'calls';
          return <button key={tab.id} onClick={() => onTabChange(tab.id)} className="relative flex flex-col items-center justify-center w-[50px] py-1 rounded-xl transition-colors focus:outline-none" data-id="element-1045" data-mp="kduygiw6rsee">
                {/* Active background indicator */}
                {isActive && <motion.div layoutId="activeTabBg" className={`absolute inset-0 rounded-xl ${isLight ? 'bg-vexu/[0.07]' : 'bg-vexu/[0.08]'}`} transition={{
              type: 'spring',
              stiffness: 500,
              damping: 35
            }} data-id="element-1046" data-mp="2malnze2rplog" />}

                {/* Icon container */}
                <div className="relative z-10 flex items-center justify-center" data-id="element-1047" data-mp="35x9xavrczx5x">
                  {isCalls && !isActive ? <div className={`w-7 h-7 rounded-full border flex items-center justify-center ${isLight ? 'bg-vexu/[0.04] border-vexu/[0.08]' : 'bg-vexu/[0.06] border-vexu/[0.1]'}`} data-id="element-1048" data-mp="2w1gnvl8xsjsd">
                      <Icon className={`w-[15px] h-[15px] ${isLight ? 'text-vexu' : 'text-vexu/60'}`} strokeWidth={1.8} data-id="element-1049" data-mp="1kl02zcem5ay4" />
                    </div> : isCalls && isActive ? <div className={`w-7 h-7 rounded-full flex items-center justify-center ${isLight ? 'bg-vexu text-white shadow-sm shadow-vexu/15' : 'bg-vexu/15 text-vexu'}`} data-id="element-1050" data-mp="1kgalivsteszo">
                      <motion.div initial={{
                  scale: 0.85
                }} animate={{
                  scale: 1
                }} transition={{
                  type: 'spring',
                  stiffness: 500,
                  damping: 25
                }} data-id="element-1051" data-mp="1t94698r16kkx">
                        <Icon className="w-[15px] h-[15px]" strokeWidth={2.2} data-id="element-1052" data-mp="8ulmapwjat61" />
                      </motion.div>
                    </div> : <motion.div animate={{
                y: isActive ? -0.5 : 0
              }} transition={{
                type: 'spring',
                stiffness: 400,
                damping: 25
              }} data-id="element-1053" data-mp="247wgaokmy18b">
                      <Icon className={`w-[17px] h-[17px] transition-colors duration-200 ${isActive ? isLight ? 'text-vexu-700' : 'text-vexu' : isLight ? 'text-slate-400' : 'text-zinc-500'}`} strokeWidth={isActive ? 2.2 : 1.6} data-id="element-1054" data-mp="288gcnpxdx0te" />
                    </motion.div>}
                </div>

                {/* Label */}
                <motion.span animate={{
              opacity: isActive ? 1 : 0.45
            }} transition={{
              duration: 0.2
            }} className={`relative z-10 text-[9px] font-medium mt-0.5 tracking-wide transition-colors duration-200 ${isActive ? isLight ? 'text-vexu-700' : 'text-vexu' : isLight ? 'text-slate-400' : 'text-zinc-500'}`} data-id="element-1055" data-mp="1phyolynhyted">
                  {tab.label}
                </motion.span>
              </button>;
        })}
        </div>
      </motion.nav>
    </div>;
}